import React from 'react';
import { Chip, Spinner, Tooltip } from 'design-system';
import { useObjectPreview } from 'corp/hooks/smartId/useObjectPreview';
import { INamedObjectTypes, IPermissionGroupPreviewJson } from '@scale/shared/types/lookup';
import IsomorphicLink from 'corp/components/UI/IsomorphicLink';
import moment from 'moment';
import { useRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';

const PermissionGroupPreview: React.FC<{ id: string }> = ({ id }) => {
  const {
    value: permissionGroup,
    loading,
    error,
  } = useObjectPreview<IPermissionGroupPreviewJson>(id, INamedObjectTypes.PermissionGroup);
  const { isRemoAdmin } = useRemoAdminCtx();
  if (error) return <span>Sorry, there was an error</span>;
  if (loading) return <Spinner />;
  return (
    <div className="permission-group-preview">
      <style jsx>{`
        .permission-group-preview__banner {
          font-weight: bold;
          padding: 10px;
          display: flex;
          align-items: center;
        }

        .permission-group-preview__thing-list > div {
          display: flex;
        }

        .permission-group-preview__thing-list strong {
          color: #666;
          margin-right: 10px;
          min-width: 120px;
          text-align: right;
        }
      `}</style>
      <div className="permission-group-preview__banner">
        <Chip label={permissionGroup?.taskType} />
        <h3 style={{ margin: '0 5px' }}>{permissionGroup?.name}</h3>
      </div>
      <div className="permission-group-preview__body">
        <div className="permission-group-preview__thing-list">
          <div>
            <strong>Lookup page</strong>
            <IsomorphicLink target="_blank" rel="noopener noreferrer" href={`/lookup/${id}`}>
              {id}{' '}
            </IsomorphicLink>
          </div>
          {!isRemoAdmin && (
            <div>
              <strong>Task Customer</strong>
              <IsomorphicLink
                target="_blank"
                rel="noopener noreferrer"
                href={`/lookup/${permissionGroup?.taskCustomer?._id}`}
              >
                {permissionGroup?.taskCustomer?.email}{' '}
              </IsomorphicLink>
            </div>
          )}
          {!!permissionGroup?.createdAt && (
            <div>
              <strong>Created</strong>
              <Tooltip
                placement={'top'}
                title={new Date(permissionGroup?.createdAt).toLocaleString()}
              >
                <span>{moment(permissionGroup?.createdAt).fromNow()}</span>
              </Tooltip>
            </div>
          )}

          <div>
            <strong>Projects</strong>
            <span style={{ maxWidth: '300px' }}>
              {permissionGroup?.projects ? (
                permissionGroup?.projects?.map(({ _id: projectId, name }, index) => (
                  <span key={projectId}>
                    {!!index && ', '}
                    <a target="blank" rel="noopener noreferrer" href={`/qm/queue/${projectId}`}>
                      {name}
                    </a>
                  </span>
                ))
              ) : (
                <span>No projects</span>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PermissionGroupPreview;
